import * as React from 'react';

function FreestyleSkiing(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M10.105 12.59l1.082 1.11-3.39 3.483a3.213 3.213 0 01-.367 3.704L7.324 21l-1.621-1.665-1.082 1.11-1.08-1.11 1.08-1.11L3 16.557a3.028 3.028 0 011.777-.894 2.992 2.992 0 011.938.41l3.39-3.484zm-5.32-9.36a.763.763 0 01.54-.23.747.747 0 01.542.23l1.62 1.666a.796.796 0 010 1.11l9.798 10.067a2.992 2.992 0 011.938-.41 3.028 3.028 0 011.777.894l-1.62 1.667 1.08 1.11-1.081 1.11-1.081-1.11L16.676 21l-.105-.113a3.213 3.213 0 01-.367-3.704L6.406 7.118a.754.754 0 01-.54.23.754.754 0 01-.54-.23L3.702 5.45a.796.796 0 010-1.11l1.082-1.11zm14.43 0l1.082 1.11a.796.796 0 010 1.111l-1.62 1.667a.763.763 0 01-.542.23.747.747 0 01-.54-.23l-3.706 3.805-1.08-1.11 3.705-3.807a.796.796 0 010-1.11l1.62-1.666a.754.754 0 011.08 0z"
        fill="currentColor"
      />
    </svg>
  );
}

export default FreestyleSkiing;
